import { AfterViewInit, Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  standalone: false,
  selector: 'bt-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss']
})
export class ModalComponent {

  @Input() public modalTitle: string = '';
  @Input() public modalContent: any;

  @Output() public exit = new EventEmitter<any>();

  public onClose() {
    this.exit.emit();
  }
}
